import { createFileRoute } from '@tanstack/react-router'

import { loadStockPricesRedirect } from '@/screens/market/StockPricesRedirect.loader'

/**
 * `/market/prices` — Stock Prices' old URL, kept for bookmarks. The loader always redirects to
 * `/market/stock-prices`, so `component` never renders on a real visit; see `IssuesRedirect.tsx`.
 */
export const Route = createFileRoute('/_app/market/prices')({
  loader: loadStockPricesRedirect,
  component: () => null,
})
